import TextureLayer from './TextureLayer';
import { TextLayerProps } from '../types/layer';

export default class TextTextureLayer extends TextureLayer {
  private fontFamily = 'Arial';
  private readonly baseSize: number = 155;
  private color = '#ffffff';
  private text: string = 'Example';

  constructor(props: TextLayerProps) {
    super(props);

    this.baseSize = props.size;

    if (props.color) {
      this.color = props.color;
    }
    if (props.family) {
      this.fontFamily = props.family;
    }
    if (props.text) {
      this.text = props.text;
    }
    this.index = 100;
  }

  public setColor(color) {
    this.color = color;
    this.needsRender = true;
  }

  public setText(text) {
    this.text = text;
    this.needsRender = true;
  }

  public setFamily(family) {
    this.fontFamily = family;
    this.needsRender = true;
  }

  public getColor() {
    return this.color;
  }

  public getText() {
    return this.text;
  }

  public getMeta() {
    return { text: this.getText(), color: this.getColor(), family: this.fontFamily };
  }

  private computeScale() {
    return Math.min(this.width / this.context.measureText(this.text).width, 1);
  }

  render(size) {
    if (!super.render(size)) return false;

    this.context.font = `${this.baseSize}px "${this.fontFamily}"`;
    this.context.fillStyle = this.color;
    this.context.textAlign = 'center';
    this.context.textBaseline = 'top';
    const metrics = this.context.measureText(this.text)
    const scale = this.computeScale();
    this.context.translate(this.width / 2 ,metrics.actualBoundingBoxAscent + 15);
    this.context.scale(scale, scale);
    this.context.fillText(this.text, 0, 0);
    this.context.resetTransform();
    return true;
  }

  getComputedFontSize(){
    return this.baseSize * this.computeScale();
  }

  toJSON() {
    return {
      image: this.getCanvas().toDataURL(),
      text: this.text,
      fontFamily: this.fontFamily,
      color: this.color,
      baseSize: this.baseSize
    };
  }
}
